<script>
let customerId = window.localStorage.getItem("customerId");
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import ImportTemplate from "@/views/components/common/form/commonImportTemplate.vue";
import config from "@/../config";
import detailsVue from "./details.vue";

export default {
  extends: baseList,
  components: {
    detailsVue,
  },
  data() {
    return {
      table: {
        mname: "commondescr",
        key: "id",
        url: {
          del: "/admin/system/common",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "system/commondescr/add",
        },
        // {
        //   label: "导入字典",
        //   icon: "md-cloud-upload",
        //   onClick: this.toImport,
        //   auth: "",
        //   type: "info",
        // },
        // {
        //   label: "下载模板",
        //   icon: "md-log-out",
        //   onClick: this.toDownload,
        //   auth: "system/commondescr/download",
        //   type: "info",
        // },
        // {
        //   label: "导出字典",
        //   icon: "md-download",
        //   type: "info",
        //   onClick: this.exportData.bind(this, "服务字典列表", 6),
        //   auth: "system/commondescr/exportData",
        // },
      ],
      // menus: [
      //   {
      //     label: "大屏监控",
      //     name: "largeScreen",
      //     auth: "",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "",
      //   },
      // ],
      //   {
      //     label: "常用语",
      //     name: "commondescr_list_main",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "服务字典",
      //     name: "serveKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库",
      //     name: "issueKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "知识库审核",
      //     name: "auditKnowledgeBase",
      //     auth: "system/commondescr/index",
      //   },
      //   {
      //     label: "工单类型",
      //     name: "worktype_list",
      //     auth: "system/worktype/index",
      //   },
      //   // {
      //   //   label: "供应商",
      //   //   name: "supplier_main",
      //   //   auth: "system/supplier/index",
      //   // },
      //   {
      //     label: "资产类型",
      //     name: "deviceClass_list",
      //     auth: "system/deviceClass/index",
      //   },
      //   {
      //     label: "型号库",
      //     name: "deviceType_list",
      //     auth: "",
      //   },
      //   {
      //     label: "耗材分类",
      //     name: "consumablesClass_list",
      //     auth: "system/consumablesClass/index",
      //     show: !(Number(customerId) === 0),
      //   },
      //   {
      //     label: "楼宇管理",
      //     name: "offices_building_list",
      //     auth: "system/offices/index",
      //   },
      //   // {
      //   //   label: "巡检模板",
      //   //   name: "templateManagement_list",
      //   //   auth: "system/templateManagement/index",
      //   // },
      //   {
      //     label: "巡检类别",
      //     name: "category_list",
      //     auth: "system/category/index",
      //   },
      //   {
      //     label: "巡检项",
      //     name: "scene_list",
      //     auth: "system/scene/index",
      //   },
      //   {
      //     label: "坐席列表",
      //     name: "callConfig_list",
      //     auth: "/admin/callConfig/lists",
      //   },

      //   {
      //     label: "投诉管理",
      //     name: "feedback_list",
      //     auth: "/admin/feedback/lists",
      //   },
      //   {
      //     label: "流程管理",
      //     name: "approvalProcess_list",
      //     auth: "",
      //   },

      // ],
      filters: [
        {
          label: "字典内容",
          name: "descr",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "工单类型",
          name: "workTypeId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
      ],
      tableCols: [
        {
          // type: "selection",
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        // {
        //   title: '类型',
        //   key: 'workType',
        //   width: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.workType == 1 ? "报修内容" : ''
        //     return (
        //       <span>{text}</span>
        //     );
        //   },
        // },
        // {
        //   title: "工单类型",
        //   key: "workTypeName",
        //   minWidth: 180,
        //   align: "center",
        //   tooltip: "true",
        // },
        {
          title: "内容",
          minWidth: 180,
          align: "left",
          render: (h, p) => {
            let item = p.row;
            let directives = [
              { name: "auth", value: "system/commondescr/details" },
            ];
            return (
              <div style={{ fontSize: "16px" }}>
                <span>[{item.workTypeName}] </span>
                <span
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toDetails(item)}
                  type="default"
                  style={{ color: "#4991ff", cursor: "pointer" }}
                >
                  {" "}
                  {item.descr}
                </span>
                {item.publicState != 1 ? (
                  <span
                    onClick={() => this.issue(item)}
                    style={{ margin: "0 0 0 5px" }}
                  >
                    <Icon
                      type="ios-cloud-upload-outline"
                      size="18"
                      color="#000"
                    />
                  </span>
                ) : (
                  ""
                )}

                {/* <span><Icon type="ios-cloud-download-outline" size="18" color="#000" /></span> */}

                <span
                  onClick={() => this.handleEdit(item)}
                  style={{ margin: "0 5px" }}
                >
                  <Icon type="ios-create-outline" size="18" color="#000" />
                </span>

                <span onClick={() => this.onDelModal(item)}>
                  <Icon type="ios-trash-outline" size="18" color="#000" />
                </span>

                <span style={{ margin: "0 5px" }}>
                  <Icon type="md-heart-outline" size="16" />
                  {item.giveNum}{" "}
                </span>

                <span>
                  <Icon type="ios-eye-outline" size="22" />
                  {item.visitNum}{" "}
                </span>
              </div>
            );
          },
        },

        // {
        //   title: "推荐方案",
        //   key: "recommendation",
        //   minWidth: 200,
        //   align: "left",
        //   tooltip: "true",
        // },

        // {
        //   title: "操作",
        //   align: "center",
        //   minWidth: 240,
        //   key: "handle",
        //   handle: [(vm, h, currentRow, param) => {
        //     // let directives = []
        //     if (currentRow.publicState != 1) {
        //       return (
        //         <Button
        //           size="small"
        //           onClick={() => this.issue(currentRow)}
        //           type="default"
        //           style={{ border: "none", marginLeft: "5px", marginRight: "5px", color: "#4991ff" }}
        //         >
        //           发布
        //         </Button>
        //       );
        //     }
        //   }, (vm, h, currentRow, param) => {
        //     // let directives = []
        //     let directives = [
        //       { name: "auth", value: "system/commondescr/details" },
        //     ];
        //     return (
        //       <Button
        //         {...{ directives }}
        //         size="small"
        //         onClick={() => this.toDetails(currentRow)}
        //         type="default"
        //         style={{ border: "none", marginLeft: "5px", marginRight: "5px", color: "#4991ff" }}
        //       >
        //         详情
        //       </Button>
        //     );
        //   }, "edit", "delete"],
        //   auth: {
        //     edit: "system/commondescr/edit",
        //     del: "system/commondescr/delete",
        //   },
        // },
      ],
    };
  },
  created() {
    this.loadLevelDatas();
  },
  methods: {
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "workTypeId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/common/template/download`;
    },
    async onDelModal(params) {
      this.$Modal.success({
        closable: true,
        title: "确认将知识文档删除吗？",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <div style="display:flex; justify-content: center; margin:40px 0">
                <Button
                  type="primary"
                  style={{ margin: "0 20px 0 0" }}
                  onClick={() => {
                    this.onDel(params);
                  }}
                >
                  确认
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    async onDel(params) {
      let q = {};
      let res = await $utils.api.load(
        `/admin/system/common/${params.id}`,
        q,
        "DELETE"
      );
      if (res.code == 200) {
        this.$Modal.remove();
        $utils.toast.success("删除成功");
        this.search();
      }
    },
    toAdd() {
      $utils.url.push({
        name: "commondescr_add",
        query: { action: "add", type: 1 },
      });
    },
    toDetails(currentRow) {
      let that = this;
      // console.log(currentRow);
      // $utils.url.push({
      //   name: "knowledgeBaseDetails",
      //   query: { id: currentRow.id },
      // });
      let customComponent = this.$createElement(detailsVue, {
        props: {
          row: currentRow,
        },
      });
      this.$drawer.show({
        visible: true,
        title: currentRow.workTypeName,
        size: "50%",
        direction: "rtl",
        content: customComponent,
        beforeClose: () => {
          // 在关闭抽屉前执行一些操作
          this.search();
        },
      });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "commondescr_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    async handIssue(currentRow) {
      let q = {};
      let res = await $utils.api.load(
        `/admin/system/common/addPublic/${currentRow.id}`,
        q,
        "post"
      );
      try {
        if (res.code == 200) {
          $utils.toast.success("发布成功,正在审核中");
          this.$Modal.remove();
          let pages = this.$store.state.app.tablePage.commondescr
            ? this.$store.state.app.tablePage.commondescr
            : 1;
          this.searchA(pages);
        }
      } catch (e) {
        $utils.toast.error(res.message);
      }
    },
    async issue(currentRow) {
      this.$Modal.success({
        closable: true,
        title: "确认将知识文档发布到公共知识库吗？",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <div style="display:flex; justify-content: center; margin:40px 0;">
                <Button
                  type="primary"
                  style={{ margin: "0 20px 0 0" }}
                  onClick={() => {
                    this.handIssue(currentRow);
                  }}
                >
                  确认
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
  },
};
</script>
<style scoped></style>
